export function buildInboxLocalPart(username, inboxSubdomain, isAdmin) {
  const name = username?.trim().toLowerCase() || "";
  if (!name) return "";
  if (isAdmin || !inboxSubdomain) return name;
  return `${name}.${inboxSubdomain}`;
}

export function formatInboxEmail(username, inboxSubdomain, isAdmin) {
  const localPart = buildInboxLocalPart(username, inboxSubdomain, isAdmin);
  if (!localPart) return "";
  return `${localPart}@ghostinbox.xyz`;
}

export function isValidInboxUsername(name) {
  const normalized = name?.trim().toLowerCase() || "";
  if (normalized.length < 3 || normalized.length > 32) return false;
  return /^[a-z0-9][a-z0-9._-]{1,30}[a-z0-9]$/.test(normalized);
}
